import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import DentiFixPage from './DentiFixPage';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HelmetProvider>
    <DentiFixPage />
  </HelmetProvider>
); 